"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchDocParser = void 0;
const StreamParser_1 = require("./binary/StreamParser");
const AltiumSchematic_1 = require("../helpers/AltiumSchematic");
const RecordParser_1 = require("../records/RecordParser");
const RecordTypes_1 = require("../records/RecordTypes");
const AsciiStreamParser_1 = require("./ascii/AsciiStreamParser");
const CFB_MAGIC = new Uint8Array([0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1]);
class SchDocParser {
    constructor(streamParser, fileName) {
        this.streamParser = streamParser;
        this.fileName = fileName;
    }
    static async FromBlob(blob, fileName) {
        if (await SchDocParser.IsCfb(blob)) {
            const streamParser = await StreamParser_1.StreamParser.fromBlob(blob);
            return new SchDocParser(streamParser, fileName);
        }
        else {
            const streamParser = await AsciiStreamParser_1.AsciiStreamParser.fromBlob(blob);
            return new SchDocParser(streamParser, fileName);
        }
    }
    static async IsCfb(blob) {
        const header = new Uint8Array(await blob.slice(0, CFB_MAGIC.length).arrayBuffer());
        return header.length >= CFB_MAGIC.length && header.every((byte, i) => byte === CFB_MAGIC[i]);
    }
    async parse() {
        const storageData = await this.streamParser.parseStorage();
        const storage = this.buildStorageMap(storageData);
        const fileHeaderRecords = await this.streamParser.parseFileHeader();
        let additionalRecords;
        try {
            additionalRecords = await this.streamParser.parseAdditional();
        }
        catch {
            additionalRecords = undefined;
        }
        const records = this.buildRecords(fileHeaderRecords, additionalRecords ?? []);
        const version = this.extractVersion(records);
        return new AltiumSchematic_1.AltiumSchematic(version, this.fileName, storage, records, storageData?.processingResults ?? []);
    }
    buildStorageMap(storageData) {
        const storage = new Map();
        if (storageData === undefined) {
            return storage;
        }
        for (const file of storageData.files) {
            storage.set(file.fileName, file.data);
        }
        return storage;
    }
    buildRecords(...propertyRecordGroups) {
        const records = [];
        const releasedProperties = {};
        const strings = new Map();
        const intern = (value) => {
            const existing = strings.get(value);
            if (existing !== undefined) {
                return existing;
            }
            strings.set(value, value);
            return value;
        };
        for (const propertyRecords of propertyRecordGroups) {
            for (let index = 0; index < propertyRecords.length; index++) {
                const properties = propertyRecords[index];
                for (const property of Object.values(properties)) {
                    if (property !== undefined) {
                        property.key = intern(property.key);
                        property.value = intern(property.value);
                    }
                }
                records.push(this.createRecord(records.length, properties));
                propertyRecords[index] = releasedProperties;
            }
        }
        return records;
    }
    createRecord(index, properties) {
        const recordTypeStr = properties.record?.value ?? '0';
        const recordType = parseInt(recordTypeStr, 10);
        const ownerIndexStr = properties.ownerindex?.value ?? '-1';
        let ownerIndex = parseInt(ownerIndexStr, 10);
        if (ownerIndex >= 0) {
            ownerIndex += 1;
        }
        return RecordParser_1.RecordParser.parseRecord(recordType, index, ownerIndex, properties);
    }
    extractVersion(records) {
        const headerRecord = records.find(RecordTypes_1.isHeaderRecord);
        if (!headerRecord) {
            throw new Error('HEADER record not found');
        }
        if (headerRecord.majorVersion && headerRecord.minorVersion) {
            return `${headerRecord.majorVersion}.${headerRecord.minorVersion}`;
        }
        else if (headerRecord.majorVersion) {
            return `${headerRecord.majorVersion}.x`;
        }
        return 'Unknown';
    }
}
exports.SchDocParser = SchDocParser;
//# sourceMappingURL=SchDocParser.js.map